import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac2000',
    ecrans: ['00-2'],
    params: ['etrcleint', '?erdcleint']
});
